import { useEffect, useId, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { acceptTerms, hasAcceptedTerms } from '../utils/termsAcceptance';

export default function TermsAcceptanceModal() {
  const { t } = useLanguage();
  const location = useLocation();
  const checkboxId = useId();
  const [visible, setVisible] = useState(() => !hasAcceptedTerms());
  const [agreed, setAgreed] = useState(false);
  const [declined, setDeclined] = useState(false);
  const onTermsPage = location.pathname === '/terms';
  const showGate = visible && !onTermsPage;

  useEffect(() => {
    if (!showGate) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showGate]);

  function handleAccept() {
    acceptTerms();
    setVisible(false);
  }

  if (!showGate) return null;

  return (
    <div className="terms-gate" role="presentation">
      <div
        className="terms-gate__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-gate-title"
        aria-describedby="terms-gate-desc"
      >
        <h2 id="terms-gate-title" className="terms-gate__title">
          {t('termsGate.title')}
        </h2>
        <p id="terms-gate-desc" className="terms-gate__lead">
          {t('termsGate.lead')}
        </p>

        {declined ? (
          <p className="terms-gate__declined" role="alert">
            {t('termsGate.declinedMessage')}
          </p>
        ) : null}

        <label className="terms-gate__checkbox" htmlFor={checkboxId}>
          <input
            id={checkboxId}
            type="checkbox"
            checked={agreed}
            onChange={(event) => setAgreed(event.target.checked)}
          />
          <span>
            {t('termsGate.checkboxPrefix')}{' '}
            <Link to="/terms" className="terms-gate__link">
              {t('termsGate.termsLink')}
            </Link>
          </span>
        </label>

        <div className="terms-gate__actions">
          <button
            type="button"
            className="terms-gate__accept"
            disabled={!agreed}
            onClick={handleAccept}
          >
            {t('termsGate.accept')}
          </button>
          <button
            type="button"
            className="terms-gate__decline"
            onClick={() => setDeclined(true)}
          >
            {t('termsGate.decline')}
          </button>
        </div>
      </div>
    </div>
  );
}
